import { Component, Inject , OnInit, Renderer2 } from '@angular/core';
import { GlobalService, JwtService, LocalStorageService } from 'src/app/services/index.service';
import { DOCUMENT } from '@angular/common';
import { HeaderService } from './header.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { environment } from 'src/environments/environment';

const sideNavAnimation = trigger('sideNavAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(+100%)' }),
    animate('0.25s 0.2s ease-out', style({ transform: 'translateX(0%)' })),
  ]),
  transition(':leave', [
    animate('0.25s 0.35s ease-in', style({ transform: 'translateX(+100%)' })),
  ]),
]);

const headerAnimation = trigger('headerAnimation', [
  transition('hide=>show', [
    style({ transform: 'translateY(-100%)' }),
    animate('0.2s 0.6s ease-out', style({ transform: 'translateY(0%)' })),
  ]),
  transition('show=>hide', [
    animate('0.2s ease-in', style({ transform: 'translateY(-100%)' })),
  ]),
]);

const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('0.25s ease-out', style({ opacity: 0.5})),
  ]),
  transition(':leave', [
    animate('0.25s ease-in', style({ opacity: 0 })),
  ]),
]);

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [ sideNavAnimation, headerAnimation, fadeAnimation ]
})
export class HeaderComponent implements OnInit {
  isDark?:boolean = false;
  constructor(
    private storage:LocalStorageService,
    private rendrer:Renderer2,
    @Inject(DOCUMENT) private document:Document,
    public global:GlobalService,
    public jwt:JwtService,
    private header: HeaderService,
    public sidenavService:HeaderService,
  ) { }
  ngOnInit() {
    this.getTheme()
    this.sidenavService.getSideBarStatusObs().subscribe(
      (state:boolean)=>{
        this.global.lockScroll(!state)
      }
    )
  }
  isOrganUser(){
    return this.global.checkUserIsOrganObs()
  }
  isAfarine(){
    return this.global.isAfarine()
  }
  katibePathProduction(){
    if(environment.production && environment.mode.prod){
      return `/katibe/dima`
    }else{
      return '/katibe'
    }
  }
  getState():boolean{
    return this.header.sidebarStatus
  }
  changeState(){
    this.header.changeSidebarState()
  }
  scrollToViewNavigate(){
    this.global.scrollToTopOfView('body')
  }
  setTheme(): void {
    this.isDark = !this.isDark;
    if(this.isDark == true){
      this.storage.setItem("theme",'dark')
      this.rendrer.addClass(this.document.body,'dark')
    }
    else{
      this.storage.setItem("theme",'light')
      this.rendrer.removeClass(this.document.body,'dark')
    } 
  }
  getTheme() {
    let themeStatus = this.storage.getItem('theme');
    if(themeStatus == 'undefined' || themeStatus == 'light'){
      this.isDark = false
      this.rendrer.removeClass(this.document.body,'dark')
    }else if(themeStatus == 'dark'){
      this.isDark = true
      this.rendrer.addClass(this.document.body,'dark')
    }  
  }
}